module.exports = __webpack_public_path__ + "img/leg-left-front.f1d4a6e4.png";